// Validation rules
const validationRules = {
  password: {
    minLength: 8,
    requireSpecialChar: true,
    requireNumber: true,
    requireUppercase: true
  },
  email: {
    pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    maxLength: 254 // Standard maximum email length
  },
  name: {
    minLength: 2,
    maxLength: 100
  },
  textField: {
    minLength: 1, // At least 1 character (not empty)
    maxLength: 255 // Common default for text fields
  }
};

// Validation functions
const validatePassword = password => {
  const errors = [];

  if (!password || password.trim().length === 0) {
    return {
      isValid: false,
      errors: ['Password is required']
    };
  }

  if (password.length < validationRules.password.minLength) {
    errors.push(`Password must be at least ${validationRules.password.minLength} characters long`);
  }

  if (validationRules.password.requireSpecialChar && !/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
    errors.push('Password must contain at least one special character');
  }

  if (validationRules.password.requireNumber && !/[0-9]/.test(password)) {
    errors.push('Password must contain at least one number');
  }

  if (validationRules.password.requireUppercase && !/[A-Z]/.test(password)) {
    errors.push('Password must contain at least one uppercase letter');
  }

  return {
    isValid: errors.length === 0,
    errors
  };
};

const validateEmail = email => {
  if (!email || email.trim().length === 0) {
    return {
      isValid: false,
      error: 'Email is required'
    };
  }

  if (email.length > validationRules.email.maxLength) {
    return {
      isValid: false,
      error: `Email must be less than ${validationRules.email.maxLength} characters`
    };
  }

  if (!validationRules.email.pattern.test(email)) {
    return {
      isValid: false,
      error: 'Please enter a valid email address'
    };
  }

  return {
    isValid: true,
    error: ''
  };
};

const validateName = (name, fieldName = 'Name') => {
  if (!name || name.trim().length === 0) {
    return {
      isValid: false,
      error: `${fieldName} is required`
    };
  }

  if (name.trim().length < validationRules.name.minLength) {
    return {
      isValid: false,
      error: `${fieldName} must be at least ${validationRules.name.minLength} characters`
    };
  }

  if (name.trim().length > validationRules.name.maxLength) {
    return {
      isValid: false,
      error: `${fieldName} must be less than ${validationRules.name.maxLength} characters`
    };
  }

  return {
    isValid: true,
    error: ''
  };
};

const validateTextField = (text, fieldName = 'Field') => {
  if (!text || text.trim().length === 0) {
    return {
      isValid: false,
      error: `${fieldName} is required`
    };
  }

  if (text.trim().length < validationRules.textField.minLength) {
    return {
      isValid: false,
      error: `${fieldName} must be at least ${validationRules.textField.minLength} character(s)`
    };
  }

  if (text.trim().length > validationRules.textField.maxLength) {
    return {
      isValid: false,
      error: `${fieldName} must be less than ${validationRules.textField.maxLength} characters`
    };
  }

  return {
    isValid: true,
    error: ''
  };
};

const validateEmployeeId = employeeId => {
  return validateTextField(employeeId, 'Employee ID');
};

export {
  validatePassword,
  validateEmail,
  validateName,
  validateEmployeeId,
  validateTextField,
  validationRules
};
